import { ref, computed, watch } from "vue";
import { useAuth, useAlertStore } from "../../stores";
import { changePassword } from "../../Actions/AuthActions";
import { useField, useForm } from "vee-validate";

export default {
  setup() {
    const authStore = useAuth();
    const alertStore = useAlertStore();
    const currentPasswordVisible = ref(false);
    const newPasswordVisible = ref(false);
    const confirmPasswordVisible = ref(false);
    const dialog = computed({
      get: () => authStore.changePasswordDialog,
      set: (value) => authStore.setChangePasswordDialog(value),
    });
    let currPass = "";
    const { handleSubmit, handleReset, validate } = useForm({
      validationSchema: {
        currentPassword(value) {
          currPass = value;
          if (value?.length >= 8) return true;

          return "Please enter a valid password with minimum 8 characters long.";
        },
        newPassword(value) {
          if (value?.length < 8) 
            return "Please enter a valid password with minimum 8 characters long.";

          else if (value === currPass) 
            return "Current password should not accept for new password."
          
          return true;
        },
        confirmPassword(value) {
          if (value?.length >= 8 && value === newPassword.value._value)
            return true;

          return "Confirm Password does not match with password.";
        },
      },
    });

    const currentPassword = useField("currentPassword");
    const newPassword = useField("newPassword");
    const confirmPassword = useField("confirmPassword");

    const submit = handleSubmit((values) => {
      changePassword({
        user: {
          current_password: values.currentPassword,
          password: values.newPassword,
          password_confirmation: values.confirmPassword,
        },
      }).then((res) => {
        if (res.status === 200) {
          alertStore.setAlertMessage(
            "success",
            "Password updated successfully. Please signin again with updated password.",
            true
          );
          authStore.setChangePasswordDialog(false);
          authStore.setTransactionToken("");
          authStore.setLoginDialog(true);
          authStore.signOut("", false);
        } else {
          alertStore.setAlertMessage("error", res.data?.errors, true);
        }
      });
    });

    watch(dialog, () => {
      handleReset();
      currentPasswordVisible.value=false;
      newPasswordVisible.value=false;
      currentPasswordVisible.value=false
    })

    const passwordVisibility = (state) => {
      if (state==='current')
        currentPasswordVisible.value = !currentPasswordVisible.value;
      else if (state==='new')
        newPasswordVisible.value = !newPasswordVisible.value;
      else if (state==='confirm')
        confirmPasswordVisible.value = !confirmPasswordVisible.value;
    };

    return {
      newPassword,
      confirmPassword,
      currentPassword,
      currentPasswordVisible,
      newPasswordVisible,
      confirmPasswordVisible,
      dialog,
      submit,
      passwordVisibility,
    };
  },
};
